/**
 * API文档地址
 * http://yapi.kapeixi.cn/project/777/interface/api/cat_4802
 */
import Storage from 'utils/Storage.js'
import { message } from 'ant-design-vue'
import {
  config_list_category_size_post,
  config_list_config_post,
  config_list_config_flow_days_post,
  config_list_config_flow_days_report_post,
  config_list_config_permissions_post,
  config_list_config_product_price_post,
  config_list_config_size_post,
  config_list_config_staff_match_post,
  config_list_process_post,
  config_list_product_category_post,
  config_list_product_second_category_post,
  config_list_staff_post,
  config_list_staff_all_post,
  config_query_config_permissions_post,
  config_submit_config_benefit_post,
  config_submit_config_warehouse_post,
  config_update_config_flow_day_post,
  config_update_config_permissions_post,
  config_submit_config_supplier_info_post,
  config_staff_post,
  config_get_supplier_type_post,
  config_timeline_add_work_bench_relation_post,
  config_timeline_delete_work_bench_relation_post,
  config_timeline_list_work_bench_relation_post,
  config_list_product_category_block_post,
  config_add_business_group_designer_post,
  config_add_category_price_post,
  config_add_config_automatic_number_post,
  config_add_config_business_group_post,
  config_add_config_designer_post,
  config_add_config_dimensional_position_post,
  config_add_config_flow_day_post,
  config_add_config_permissions_post,
  config_add_config_plate_shape_attr_post,
  config_add_config_product_price_post,
  config_add_config_product_size_post,
  config_add_config_purchaser_supplier_post,
  config_add_config_report_defect_post,
  config_add_config_staff_match_post,
  config_add_config_tag_ref_product_highlights_post,
  config_add_config_target_price_post,
  config_add_config_theme_post,
  config_add_config_water_washing_symbol_post,
  config_add_expected_sessions_post,
  config_add_holiday_post,
  config_add_pricing_supplier_post,
  config_add_process_post,
  config_add_process_node_post,
  config_add_process_node_relation_post,
  config_add_process_node_state_post,
  config_add_standing_special_material_post,
  config_add_supplier_cycle_post,
  config_add_to_ekb_code_post,
  config_add_to_ekb_code2_post,
  config_add_update_salary_post,
  config_batch_update_supplier_post,
  config_del_config_flow_day_post,
  config_del_config_permissions_post,
  config_del_config_product_price_post,
  config_del_config_purchaser_supplier_post,
  config_del_config_staff_match_post,
  config_del_supplier_cycle_get,
  config_delete_config_automatic_number_post,
  config_delete_config_dimensional_position_post,
  config_delete_config_target_price_post,
  config_delete_pricing_supplier_post,
  config_delete_process_node_post,
  config_delete_process_node_relation_post,
  config_delete_process_node_state_post,
  config_delete_standing_special_material_post,
  config_detail_category_price_get,
  config_detail_salary_get,
  config_disableAccount_post,
  config_edit_business_group_designer_post,
  config_edit_config_automatic_number_post,
  config_edit_config_business_group_post,
  config_edit_config_designer_post,
  config_edit_config_dimensional_position_post,
  config_edit_config_plate_shape_attr_post,
  config_edit_config_report_defect_post,
  config_edit_config_tag_ref_product_highlights_post,
  config_edit_config_target_price_post,
  config_edit_config_theme_post,
  config_edit_config_water_washing_symbol_post,
  config_enableAccount_post,
  config_executeSupplierAccountToEkb_post,
  config_export_post,
  config_get_batch_update_supplier_url_post,
  config_get_config_role_post,
  config_get_cp_by_skc_post,
  config_get_expected_sessions_post,
  config_get_pricing_supplier_post,
  config_get_process_node_post,
  config_get_process_node_url_post,
  config_get_standing_special_material_post,
  config_get_supplier_account_post,
  config_get_supplier_attribute_post,
  config_get_supplier_type_get,
  config_importSupplierInfo_post,
  config_init_cp_skc_post,
  config_list_business_group_post,
  config_list_business_group_designer_post,
  config_list_category_price_post,
  config_list_category_product_post,
  config_list_column_post,
  config_list_config_automatic_number_post,
  config_list_config_benefit_post,
  config_list_config_business_group_post,
  config_list_config_designer_post,
  config_list_config_dimensional_position_post,
  config_list_config_plate_shape_attr_post,
  config_list_config_purchaser_supplier_post,
  config_list_config_report_defect_post,
  config_list_config_supplier_info_post,
  config_list_config_symbol_ref_material_post,
  config_list_config_tag_ref_product_highlights_post,
  config_list_config_target_price_post,
  config_list_config_theme_post,
  config_list_config_warehouse_post,
  config_list_config_water_washing_symbol_post,
  config_list_holiday_post,
  config_list_material_post,
  config_list_material_name_post,
  config_list_menu_field_post,
  config_list_node_user_post,
  config_list_process_name_post,
  config_list_process_node_post,
  config_list_process_node_name_post,
  config_list_process_node_relation_post,
  config_list_process_node_state_post,
  config_list_salary_post,
  config_list_supplier_cycle_post,
  config_page_config_plate_shape_attr_post,
  config_page_config_plate_shape_attr_by_cp_post,
  config_qr_code_url_post,
  config_query_menu_button_post,
  config_query_product_highlights_by_tag_post,
  config_renew_process_name_post,
  config_renew_process_name_v2_post,
  config_reset_password_post,
  config_spl_review_edit_config_post,
  config_spl_review_list_config_post,
  config_submit_edit_add_supplier_post,
  config_supplier_edit_infos_post,
  config_sync_category_product_get,
  config_timeline_add_process_post,
  config_timeline_add_process_node_post,
  config_timeline_add_process_node_relation_post,
  config_timeline_add_work_bench_post,
  config_timeline_business_group_post,
  config_timeline_change_post,
  config_timeline_control_list_post,
  config_timeline_delete_process_node_post,
  config_timeline_delete_process_node_relation_post,
  config_timeline_delete_work_bench_post,
  config_timeline_export_statement_post,
  config_timeline_export_statement_detail_post,
  config_timeline_export_statement_nodecode_post,
  config_timeline_export_statement_overview_post,
  config_timeline_export_statement_page_turns_post,
  config_timeline_list_process_post,
  config_timeline_list_work_bench_post,
  config_timeline_process_node_post,
  config_timeline_process_node_relation_post,
  config_timeline_statement_post,
  config_timeline_statement_detail_post,
  config_timeline_statement_overview_post,
  config_timeline_type_post,
  config_update_config_purchaser_supplier_post,
  config_update_config_symbol_ref_material_post,
  config_update_expected_sessions_post,
  config_update_menu_field_post,
  config_update_node_user_post,
  config_update_node_user_state_post,
  config_update_pricing_supplier_post,
  config_update_standing_special_material_post,
  config_update_supplier_account_post,
  config_upload_process_node_post,
  config_list_config_outsource_exception_type_post,
  config_add_config_outsource_exception_type_post,
  config_edit_config_outsource_exception_type_post,
  config_list_column_cp_skc_post,
  config_add_config_craftsman_ref_post,
  config_delete_config_craftsman_ref_post,
  config_edit_config_craftsman_ref_post,
  config_list_config_craftsman_ref_post,
  config_list_config_function_special_post,
  config_add_config_popo_notify_post,
  config_delete_config_popo_notify_post,
  config_edit_config_popo_notify_post,
  config_list_config_popo_notify_post,
  config_all_config_popo_notify_post,
  config_batch_delete_config_popo_notify_post,
  config_batch_update_config_popo_notify_status_post,
  config_delete_config_popo_notify_content_post,
  config_timeline_getTimeLineEndTime_post
} from 'server/modules/4802'

// 查询服装配置码值列表
export const config_list_category_size_post_ = async function(params) {
  const { success, data, retInfo } = await config_list_category_size_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 系统配置列表查询
export const config_list_config_post_ = async function(params) {
  const { success, data, retInfo } = await config_list_config_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 流程节点天数配置查询
export const config_list_config_flow_days_post_ = async function(params) {
  const { success, data, retInfo } = await config_list_config_flow_days_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 报表流程节点天数
export const config_list_config_flow_days_report_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await config_list_config_flow_days_report_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 工作台权限配置列表
export const config_list_config_permissions_post_ = async function(params) {
  const { success, data, retInfo } = await config_list_config_permissions_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 产品品类对应价格占比配置表查询
export const config_list_config_product_price_post_ = async function(params) {
  const {
    success,
    data,
    retInfo
  } = await config_list_config_product_price_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 系统配置列表查询
export const config_list_config_size_post_ = async function(params) {
  const { success, data, retInfo } = await config_list_config_size_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 设计师、版师、工艺员对应关系配置查询
export const config_list_config_staff_match_post_ = async function(params) {
  const { success, data, retInfo } = await config_list_config_staff_match_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 查询流程配置
export const config_list_process_post_ = async function(params) {
  const { success, data, retInfo } = await config_list_process_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 查询产品分类
export const config_list_product_category_post_ = async function(params) {
  const { success, data, retInfo } = await config_list_product_category_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 查询产品分类(精确到二级类目)
export const config_list_product_second_category_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await config_list_product_second_category_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 员工查询信息
export const config_list_staff_post_ = async function(params) {
  const { success, data, retInfo } = await config_list_staff_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 员工查询信息
export const config_list_staff_all_post_ = async function(params) {
  const { success, data, retInfo } = await config_list_staff_all_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 查询用户权限
export const config_query_config_permissions_post_ = async function(params) {
  const { success, data, retInfo } = await config_query_config_permissions_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 提交利润率配置
export const config_submit_config_benefit_post_ = async function(params) {
  const { success, data, retInfo } = await config_submit_config_benefit_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 提交供应商仓库映射配置
export const config_submit_config_warehouse_post_ = async function(params) {
  const { success, data, retInfo } = await config_submit_config_warehouse_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 更新流程节点天数配置
export const config_update_config_flow_day_post_ = async function(params) {
  const { success, data, retInfo } = await config_update_config_flow_day_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 更新工作台配置
export const config_update_config_permissions_post_ = async function(params) {
  const {
    success,
    data,
    retInfo
  } = await config_update_config_permissions_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 提交易仓供应商配置表
export const config_submit_config_supplier_info_post_ = async function(params) {
  const {
    success,
    data,
    retInfo
  } = await config_submit_config_supplier_info_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 员工所有信息
export const config_staff_post_ = async function(params) {
  const { success, data, retInfo } = await config_staff_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 供应商类型
export const config_get_supplier_type_post_ = async function(params) {
  const { success, data, retInfo } = await config_get_supplier_type_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 新增timeline流程类目关系配置
export const config_timeline_add_work_bench_relation_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await config_timeline_add_work_bench_relation_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 删除timeline流程类目关系配置
export const config_timeline_delete_work_bench_relation_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await config_timeline_delete_work_bench_relation_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 查询timeline流程类目关系配置
export const config_timeline_list_work_bench_relation_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await config_timeline_list_work_bench_relation_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 查询版型库产品分类
export const config_list_product_category_block_post_ = async function(params) {
  const {
    success,
    data,
    retInfo
  } = await config_list_product_category_block_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 新增业务组设计师配置
export const config_add_business_group_designer_post_ = async function(params) {
  const {
    success,
    data,
    retInfo
  } = await config_add_business_group_designer_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 报关品类价格新增
export const config_add_category_price_post_ = async function(params) {
  const { success, data, retInfo } = await config_add_category_price_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 新增cp自动取号配置
export const config_add_config_automatic_number_post_ = async function(params) {
  const {
    success,
    data,
    retInfo
  } = await config_add_config_automatic_number_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 新增业务组配置
export const config_add_config_business_group_post_ = async function(params) {
  const {
    success,
    data,
    retInfo
  } = await config_add_config_business_group_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 新增设计师配置
export const config_add_config_designer_post_ = async function(params) {
  const { success, data, retInfo } = await config_add_config_designer_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 新增尺码部位配置
export const config_add_config_dimensional_position_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await config_add_config_dimensional_position_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 新增流程节点天数配置
export const config_add_config_flow_day_post_ = async function(params) {
  const { success, data, retInfo } = await config_add_config_flow_day_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 新增工作台配置
export const config_add_config_permissions_post_ = async function(params) {
  const { success, data, retInfo } = await config_add_config_permissions_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 新增体型版型配置
export const config_add_config_plate_shape_attr_post_ = async function(params) {
  const {
    success,
    data,
    retInfo
  } = await config_add_config_plate_shape_attr_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 新增产品品类对应价格占比配置
export const config_add_config_product_price_post_ = async function(params) {
  const { success, data, retInfo } = await config_add_config_product_price_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 编辑二级品类尺码配置
export const config_add_config_product_size_post_ = async function(params) {
  const { success, data, retInfo } = await config_add_config_product_size_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 新增采购员与供应商关联配置
export const config_add_config_purchaser_supplier_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await config_add_config_purchaser_supplier_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 新增质检瑕疵配置
export const config_add_config_report_defect_post_ = async function(params) {
  const { success, data, retInfo } = await config_add_config_report_defect_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 新增设计师、版师、工艺员对应关系配置
export const config_add_config_staff_match_post_ = async function(params) {
  const { success, data, retInfo } = await config_add_config_staff_match_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 新增商品亮点关联tag配置
export const config_add_config_tag_ref_product_highlights_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await config_add_config_tag_ref_product_highlights_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 新增目标价配置
export const config_add_config_target_price_post_ = async function(params) {
  const { success, data, retInfo } = await config_add_config_target_price_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 新增主题配置
export const config_add_config_theme_post_ = async function(params) {
  const { success, data, retInfo } = await config_add_config_theme_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 新增水洗符号配置
export const config_add_config_water_washing_symbol_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await config_add_config_water_washing_symbol_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 期望场次配置 新增
export const config_add_expected_sessions_post_ = async function(params) {
  const { success, data, retInfo } = await config_add_expected_sessions_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 新增节假日配置
export const config_add_holiday_post_ = async function(params) {
  const { success, data, retInfo } = await config_add_holiday_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 核价配置 新增
export const config_add_pricing_supplier_post_ = async function(params) {
  const { success, data, retInfo } = await config_add_pricing_supplier_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 新增流程配置
export const config_add_process_post_ = async function(params) {
  const { success, data, retInfo } = await config_add_process_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 新增流程节点配置
export const config_add_process_node_post_ = async function(params) {
  const { success, data, retInfo } = await config_add_process_node_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 新增流程节点关系
export const config_add_process_node_relation_post_ = async function(params) {
  const {
    success,
    data,
    retInfo
  } = await config_add_process_node_relation_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 新增流程节点配置
export const config_add_process_node_state_post_ = async function(params) {
  const { success, data, retInfo } = await config_add_process_node_state_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 常备特殊面料 新增
export const config_add_standing_special_material_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await config_add_standing_special_material_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 提交供应商支付周期数据
export const config_add_supplier_cycle_post_ = async function(params) {
  const { success, data, retInfo } = await config_add_supplier_cycle_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 同步易快报
export const config_add_to_ekb_code_post_ = async function(params) {
  const { success, data, retInfo } = await config_add_to_ekb_code_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 同步易快报2
export const config_add_to_ekb_code2_post_ = async function(params) {
  const { success, data, retInfo } = await config_add_to_ekb_code2_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 供应商小时工资新增
export const config_add_update_salary_post_ = async function(params) {
  const { success, data, retInfo } = await config_add_update_salary_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 批量更新供应商信息
export const config_batch_update_supplier_post_ = async function(params) {
  const { success, data, retInfo } = await config_batch_update_supplier_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 删除流程节点天数配置
export const config_del_config_flow_day_post_ = async function(params) {
  const { success, data, retInfo } = await config_del_config_flow_day_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 删除工作台配置
export const config_del_config_permissions_post_ = async function(params) {
  const { success, data, retInfo } = await config_del_config_permissions_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 删除产品品类对应价格占比配置
export const config_del_config_product_price_post_ = async function(params) {
  const { success, data, retInfo } = await config_del_config_product_price_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 删除采购员与供应商关联配置
export const config_del_config_purchaser_supplier_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await config_del_config_purchaser_supplier_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 新增设计师、版师、工艺员对应关系配置
export const config_del_config_staff_match_post_ = async function(params) {
  const { success, data, retInfo } = await config_del_config_staff_match_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 删除供应商支付周期数据
export const config_del_supplier_cycle_get_ = async function(params) {
  const { success, data, retInfo } = await config_del_supplier_cycle_get(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 删除cp自动取号配置
export const config_delete_config_automatic_number_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await config_delete_config_automatic_number_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 删除尺码部位配置
export const config_delete_config_dimensional_position_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await config_delete_config_dimensional_position_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 删除目标价配置
export const config_delete_config_target_price_post_ = async function(params) {
  const {
    success,
    data,
    retInfo
  } = await config_delete_config_target_price_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 核价配置 删除
export const config_delete_pricing_supplier_post_ = async function(params) {
  const { success, data, retInfo } = await config_delete_pricing_supplier_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 刪除流程节点配置
export const config_delete_process_node_post_ = async function(params) {
  const { success, data, retInfo } = await config_delete_process_node_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 刪除流程节点关系
export const config_delete_process_node_relation_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await config_delete_process_node_relation_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 刪除流程节点配置
export const config_delete_process_node_state_post_ = async function(params) {
  const {
    success,
    data,
    retInfo
  } = await config_delete_process_node_state_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 常备特殊面料 删除
export const config_delete_standing_special_material_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await config_delete_standing_special_material_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 报关品类价格详情
export const config_detail_category_price_get_ = async function(params) {
  const { success, data, retInfo } = await config_detail_category_price_get(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 供应商小时工资详情
export const config_detail_salary_get_ = async function(params) {
  const { success, data, retInfo } = await config_detail_salary_get(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// disableAccount
export const config_disableAccount_post_ = async function(params) {
  const { success, data, retInfo } = await config_disableAccount_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 编辑业务组设计师配置
export const config_edit_business_group_designer_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await config_edit_business_group_designer_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 编辑cp自动取号配置
export const config_edit_config_automatic_number_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await config_edit_config_automatic_number_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 编辑业务组配置
export const config_edit_config_business_group_post_ = async function(params) {
  const {
    success,
    data,
    retInfo
  } = await config_edit_config_business_group_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 编辑设计师配置
export const config_edit_config_designer_post_ = async function(params) {
  const { success, data, retInfo } = await config_edit_config_designer_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 编辑尺码部位配置
export const config_edit_config_dimensional_position_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await config_edit_config_dimensional_position_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 编辑体型版型配置
export const config_edit_config_plate_shape_attr_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await config_edit_config_plate_shape_attr_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 编辑质检瑕疵配置
export const config_edit_config_report_defect_post_ = async function(params) {
  const {
    success,
    data,
    retInfo
  } = await config_edit_config_report_defect_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 编辑商品亮点关联tag配置
export const config_edit_config_tag_ref_product_highlights_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await config_edit_config_tag_ref_product_highlights_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 编辑目标价配置
export const config_edit_config_target_price_post_ = async function(params) {
  const { success, data, retInfo } = await config_edit_config_target_price_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 编辑主题配置
export const config_edit_config_theme_post_ = async function(params) {
  const { success, data, retInfo } = await config_edit_config_theme_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 编辑水洗符号配置
export const config_edit_config_water_washing_symbol_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await config_edit_config_water_washing_symbol_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// enableAccount
export const config_enableAccount_post_ = async function(params) {
  const { success, data, retInfo } = await config_enableAccount_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// executeSupplierAccountToEkb
export const config_executeSupplierAccountToEkb_post_ = async function(params) {
  const {
    success,
    data,
    retInfo
  } = await config_executeSupplierAccountToEkb_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 供应商列表导出
export const config_export_post_ = async function(params) {
  const { success, data, retInfo } = await config_export_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 批量上传cp面辅料模板下载
export const config_get_batch_update_supplier_url_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await config_get_batch_update_supplier_url_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 权限
export const config_get_config_role_post_ = async function(params) {
  const { success, data, retInfo } = await config_get_config_role_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 根据sk查询cp
export const config_get_cp_by_skc_post_ = async function(params) {
  const { success, data, retInfo } = await config_get_cp_by_skc_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 期望场次配置 列表
export const config_get_expected_sessions_post_ = async function(params) {
  const { success, data, retInfo } = await config_get_expected_sessions_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 核价配置 列表
export const config_get_pricing_supplier_post_ = async function(params) {
  const { success, data, retInfo } = await config_get_pricing_supplier_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 获取流程节点明细
export const config_get_process_node_post_ = async function(params) {
  const { success, data, retInfo } = await config_get_process_node_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 流程节点模板下载url
export const config_get_process_node_url_post_ = async function(params) {
  const { success, data, retInfo } = await config_get_process_node_url_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 常备特殊面料 列表
export const config_get_standing_special_material_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await config_get_standing_special_material_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

//  供应商账户查询
export const config_get_supplier_account_post_ = async function(params) {
  const { success, data, retInfo } = await config_get_supplier_account_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 供应商属性
export const config_get_supplier_attribute_post_ = async function(params) {
  const { success, data, retInfo } = await config_get_supplier_attribute_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 供应商类型
export const config_get_supplier_type_get_ = async function(params) {
  const { success, data, retInfo } = await config_get_supplier_type_get(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 导入价格品类
export const config_importSupplierInfo_post_ = async function(params) {
  const { success, data, retInfo } = await config_importSupplierInfo_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 初始化cp-skc
export const config_init_cp_skc_post_ = async function(params) {
  const { success, data, retInfo } = await config_init_cp_skc_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 业务组配置查询(枚举下拉使用)
export const config_list_business_group_post_ = async function(params) {
  const { success, data, retInfo } = await config_list_business_group_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 业务组设计师配置查询
export const config_list_business_group_designer_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await config_list_business_group_designer_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 报关品类价格列表
export const config_list_category_price_post_ = async function(params) {
  const { success, data, retInfo } = await config_list_category_price_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 报关品类-产品列表
export const config_list_category_product_post_ = async function(params) {
  const { success, data, retInfo } = await config_list_category_product_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 获取动态列值
export const config_list_column_post_ = async function(params) {
  const { success, data, retInfo } = await config_list_column_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// cp自动取号配置查询
export const config_list_config_automatic_number_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await config_list_config_automatic_number_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 利润率配置查询
export const config_list_config_benefit_post_ = async function(params) {
  const { success, data, retInfo } = await config_list_config_benefit_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 业务组配置查询
export const config_list_config_business_group_post_ = async function(params) {
  const {
    success,
    data,
    retInfo
  } = await config_list_config_business_group_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 设计师配置查询
export const config_list_config_designer_post_ = async function(params) {
  const { success, data, retInfo } = await config_list_config_designer_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 查询尺码部位配置
export const config_list_config_dimensional_position_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await config_list_config_dimensional_position_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 体型版型配置查询
export const config_list_config_plate_shape_attr_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await config_list_config_plate_shape_attr_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 采购员与供应商关联配置查询
export const config_list_config_purchaser_supplier_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await config_list_config_purchaser_supplier_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 质检瑕疵配置
export const config_list_config_report_defect_post_ = async function(params) {
  const {
    success,
    data,
    retInfo
  } = await config_list_config_report_defect_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 供应商主数据查询
export const config_list_config_supplier_info_post_ = async function(params) {
  const {
    success,
    data,
    retInfo
  } = await config_list_config_supplier_info_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 水洗符号与物料编码关联配置查询
export const config_list_config_symbol_ref_material_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await config_list_config_symbol_ref_material_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 商品亮点配置查询
export const config_list_config_tag_ref_product_highlights_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await config_list_config_tag_ref_product_highlights_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 目标价配置
export const config_list_config_target_price_post_ = async function(params) {
  const { success, data, retInfo } = await config_list_config_target_price_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 主题配置查询
export const config_list_config_theme_post_ = async function(params) {
  const { success, data, retInfo } = await config_list_config_theme_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 供应商仓库映射配置查询
export const config_list_config_warehouse_post_ = async function(params) {
  const { success, data, retInfo } = await config_list_config_warehouse_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 水洗符号配置查询
export const config_list_config_water_washing_symbol_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await config_list_config_water_washing_symbol_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 节假日查询
export const config_list_holiday_post_ = async function(params) {
  const { success, data, retInfo } = await config_list_holiday_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 物料名称下拉配置查询()
export const config_list_material_post_ = async function(params) {
  const { success, data, retInfo } = await config_list_material_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 物料名称下拉配置查询
export const config_list_material_name_post_ = async function(params) {
  const { success, data, retInfo } = await config_list_material_name_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 获取动态菜单列
export const config_list_menu_field_post_ = async function(props, state) {
  const { menuName, columnFixed, hasAction } = props
  // 用户拖拽保存的列宽
  const { columnWidth = {} } = state
  state.menuListFields = []
  state.columnsField = []

  // 默认获取本地的storage
  const storageFilterQuery =
    (Storage.getItem('VXE_COLUMNS_STORAGE_FILTER') || {})[menuName] ||
    props.queryParams ||
    {}
  /**
   * 根据列标题获取列宽
   * @param {*} column
   * @returns
   */
  const fixedColumnWidth = column => {
    const { columnName, isSearched, requestStr } = column
    if (column.columnWidth) {
      return column.columnWidth
    }
    if (columnWidth[requestStr]) {
      return columnWidth[requestStr]
    }
    let fixedWidth = 0
    for (let i = 0; i < columnName.length; i++) {
      const charCode = columnName.charCodeAt(i)
      if (charCode >= 0 && charCode <= 128) {
        fixedWidth += 8
      } else {
        fixedWidth += 16
      }
    }
    // 添加两边的间距 5是误差
    fixedWidth += 16 + 5
    //  有筛选
    if (isSearched === 1) {
      fixedWidth += 28
    }
    if (fixedWidth < 160) {
      return 160
    }
    if (fixedWidth > 320) {
      return 320
    }
    return fixedWidth
  }
  const getMenuListField = async () => {
    const { success, data, retInfo } = await config_list_menu_field_post({
      menuName
    })
    if (success) {
      state.menuListFields = data
      updateTableColumn()
    } else {
      console.log(data)
      message.error(retInfo)
    }
  }
  const getTableColumns = () => {
    state.serverColumns = []
    state.columnsField.length &&
      state.columnsField.map(item => {
        const {
          columnName,
          isSearched,
          requestStr,
          searchStr,
          model,
          isBatchQuery,
          freeze,
          needEmpty,
          childrenList,
          notes
        } = item

        // childrenList不为空，且二级没有被选中的类目，则整个列不展示
        if (
          !(
            childrenList &&
            childrenList.length > 0 &&
            childrenList.findIndex(item => item.isSelected === 1) === -1
          )
        ) {
          let setFilterConfig = {}
          if (isSearched === 1 && model !== 8) {
            setFilterConfig = {
              isBatch: !(isBatchQuery === 0),
              params: {
                columnName: searchStr,
                menuName,
                queryStr: model === 2 ? storageFilterQuery[searchStr]?.[0] : ''
              },
              filterValue: storageFilterQuery[searchStr] || [],
              model,
              needEmpty,
              filtered: false,
              options: [],
              customeTitle: columnName,
              notes,
              customFilterDropdown: true
            }
          }
          const fixed = freeze === 1 ? 'left' : ''

          state.serverColumns.push({
            dataIndex: requestStr,
            width: fixedColumnWidth(item),
            sorter: model === 8,
            key: requestStr,
            fixed: columnFixed[requestStr] || fixed || '',
            notes,
            title: columnName,
            childrenList:
              childrenList &&
              childrenList.filter(item => item.isSelected === 1),
            ...setFilterConfig
          })
        }
      })
    const mql = window.matchMedia('(max-width: 1400px)')
    let w = 1350
    if (mql.matches) {
      w = 800
    }
    let actionFixed = null
    if (Object.keys(columnFixed).includes('action')) {
      actionFixed = columnFixed['action']
    } else if (state.serverColumns.length * 150 > w) {
      actionFixed = 'right'
    }
    hasAction &&
      state.serverColumns.push({
        title: '操作',
        key: 'action',
        dataIndex: 'action',
        width: columnWidth.action || 180,
        align: 'center',
        fixed: actionFixed
      })
    state.createColumns(state.serverColumns)
  }
  const updateTableColumn = () => {
    state.columnsField = state.menuListFields.filter(_ => {
      return _.isSelected === 1
    })
    getTableColumns()
  }
  if (menuName) {
    getMenuListField()
  }
}

// 对应关系配置
export const config_list_node_user_post_ = async function(params) {
  const { success, data, retInfo } = await config_list_node_user_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 查询流程节点信息
export const config_list_process_name_post_ = async function(params) {
  const { success, data, retInfo } = await config_list_process_name_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 查询流程节点配置
export const config_list_process_node_post_ = async function(params) {
  const { success, data, retInfo } = await config_list_process_node_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 查询流程配置名称
export const config_list_process_node_name_post_ = async function(params) {
  const { success, data, retInfo } = await config_list_process_node_name_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 查询流程节点状态关系
export const config_list_process_node_relation_post_ = async function(params) {
  const {
    success,
    data,
    retInfo
  } = await config_list_process_node_relation_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 查询流程节点状态配置
export const config_list_process_node_state_post_ = async function(params) {
  const { success, data, retInfo } = await config_list_process_node_state_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 供应商小时工资列表
export const config_list_salary_post_ = async function(params) {
  const { success, data, retInfo } = await config_list_salary_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 查询供应商支付周期数据
export const config_list_supplier_cycle_post_ = async function(params) {
  const { success, data, retInfo } = await config_list_supplier_cycle_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 体型版型配置查询(分页)
export const config_page_config_plate_shape_attr_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await config_page_config_plate_shape_attr_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 体型版型配置查询(分页)
export const config_page_config_plate_shape_attr_by_cp_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await config_page_config_plate_shape_attr_by_cp_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 二维码
export const config_qr_code_url_post_ = async function(params) {
  const { success, data, retInfo } = await config_qr_code_url_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 查询按钮
export const config_query_menu_button_post_ = async function(params) {
  const { success, data, retInfo } = await config_query_menu_button_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 通过类目 tagId 获取商品亮点
export const config_query_product_highlights_by_tag_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await config_query_product_highlights_by_tag_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// renew流程节点信息
export const config_renew_process_name_post_ = async function(params) {
  const { success, data, retInfo } = await config_renew_process_name_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// renew流程节点信息V2
export const config_renew_process_name_v2_post_ = async function(params) {
  const { success, data, retInfo } = await config_renew_process_name_v2_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 重置密码
export const config_reset_password_post_ = async function(params) {
  const { success, data, retInfo } = await config_reset_password_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 新增或编辑审版评语配置
export const config_spl_review_edit_config_post_ = async function(params) {
  const { success, data, retInfo } = await config_spl_review_edit_config_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 查询审版评语配置
export const config_spl_review_list_config_post_ = async function(params) {
  const { success, data, retInfo } = await config_spl_review_list_config_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 提交编辑新增供应商
export const config_submit_edit_add_supplier_post_ = async function(params) {
  const { success, data, retInfo } = await config_submit_edit_add_supplier_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 供应商编辑页面
export const config_supplier_edit_infos_post_ = async function(params) {
  const { success, data, retInfo } = await config_supplier_edit_infos_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 报关品类同步
export const config_sync_category_product_get_ = async function(params) {
  const { success, data, retInfo } = await config_sync_category_product_get(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 新增timeline流程配置
export const config_timeline_add_process_post_ = async function(params) {
  const { success, data, retInfo } = await config_timeline_add_process_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 新增timeline节点配置
export const config_timeline_add_process_node_post_ = async function(params) {
  const {
    success,
    data,
    retInfo
  } = await config_timeline_add_process_node_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 新增timeline流程节点关系配置
export const config_timeline_add_process_node_relation_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await config_timeline_add_process_node_relation_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 新增timeline流程类目配置
export const config_timeline_add_work_bench_post_ = async function(params) {
  const { success, data, retInfo } = await config_timeline_add_work_bench_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// timeline 报表 - 查询部门信息
export const config_timeline_business_group_post_ = async function(params) {
  const { success, data, retInfo } = await config_timeline_business_group_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// timeline切换
export const config_timeline_change_post_ = async function(params) {
  const { success, data, retInfo } = await config_timeline_change_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 控件列表
export const config_timeline_control_list_post_ = async function(params) {
  const { success, data, retInfo } = await config_timeline_control_list_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 刪除timeline节点配置
export const config_timeline_delete_process_node_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await config_timeline_delete_process_node_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 刪除timeline节点关系配置
export const config_timeline_delete_process_node_relation_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await config_timeline_delete_process_node_relation_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 删除timeline流程类目配置
export const config_timeline_delete_work_bench_post_ = async function(params) {
  const {
    success,
    data,
    retInfo
  } = await config_timeline_delete_work_bench_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 导出统计报表
export const config_timeline_export_statement_post_ = async function(params) {
  const {
    success,
    data,
    retInfo
  } = await config_timeline_export_statement_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 导出产品明细报表
export const config_timeline_export_statement_detail_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await config_timeline_export_statement_detail_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// timeline 报表 - 导出 CP 明细表 - 节点
export const config_timeline_export_statement_nodecode_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await config_timeline_export_statement_nodecode_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// timeline 报表 - 导出 CP 明细表 - 总体数据
export const config_timeline_export_statement_overview_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await config_timeline_export_statement_overview_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// timeline 报表 - 页面跳转
export const config_timeline_export_statement_page_turns_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await config_timeline_export_statement_page_turns_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 查询timeline流程配置
export const config_timeline_list_process_post_ = async function(params) {
  const { success, data, retInfo } = await config_timeline_list_process_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 查询timeline流程类目配置
export const config_timeline_list_work_bench_post_ = async function(params) {
  const { success, data, retInfo } = await config_timeline_list_work_bench_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 查询timeline节点配置
export const config_timeline_process_node_post_ = async function(params) {
  const { success, data, retInfo } = await config_timeline_process_node_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 查询timeline节点关系
export const config_timeline_process_node_relation_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await config_timeline_process_node_relation_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// timeline 报表 - 查询 timeline 统计表
export const config_timeline_statement_post_ = async function(params) {
  const { success, data, retInfo } = await config_timeline_statement_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// timeline 报表 - 查询timeline产品明细报表
export const config_timeline_statement_detail_post_ = async function(params) {
  const {
    success,
    data,
    retInfo
  } = await config_timeline_statement_detail_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// timeline 报表 - 总体数据
export const config_timeline_statement_overview_post_ = async function(params) {
  const {
    success,
    data,
    retInfo
  } = await config_timeline_statement_overview_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// timeline 报表 - 根据模式查询 timeline 类型
export const config_timeline_type_post_ = async function(params) {
  const { success, data, retInfo } = await config_timeline_type_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 编辑采购员与供应商关联配置
export const config_update_config_purchaser_supplier_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await config_update_config_purchaser_supplier_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 水洗符号与物料编码关联配置
export const config_update_config_symbol_ref_material_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await config_update_config_symbol_ref_material_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 期望场次配置 更新
export const config_update_expected_sessions_post_ = async function(params) {
  const { success, data, retInfo } = await config_update_expected_sessions_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 更新动态菜单列
export const config_update_menu_field_post_ = async function(params) {
  const { success, data, retInfo } = await config_update_menu_field_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 对应关系配置
export const config_update_node_user_post_ = async function(params) {
  const { success, data, retInfo } = await config_update_node_user_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 对应关系更新状态
export const config_update_node_user_state_post_ = async function(params) {
  const { success, data, retInfo } = await config_update_node_user_state_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 核价配置 更新
export const config_update_pricing_supplier_post_ = async function(params) {
  const { success, data, retInfo } = await config_update_pricing_supplier_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 常备特殊面料 更新
export const config_update_standing_special_material_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await config_update_standing_special_material_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 新增或者更新新增供应商账号
export const config_update_supplier_account_post_ = async function(params) {
  const { success, data, retInfo } = await config_update_supplier_account_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 上传流程节点明细
export const config_upload_process_node_post_ = async function(params) {
  const { success, data, retInfo } = await config_upload_process_node_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 外发打样异常类型配置
export const config_list_config_outsource_exception_type_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await config_list_config_outsource_exception_type_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 新增外发打样异常类型配置
export const config_add_config_outsource_exception_type_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await config_add_config_outsource_exception_type_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 编辑外发打样异常类型配置
export const config_edit_config_outsource_exception_type_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await config_edit_config_outsource_exception_type_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 获取动态列值
export const config_list_column_cp_skc_post_ = async function(params) {
  const { success, data, retInfo } = await config_list_column_cp_skc_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 新增工艺员审版师配置
export const config_add_config_craftsman_ref_post_ = async function(params) {
  const { success, data, retInfo } = await config_add_config_craftsman_ref_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 删除工艺员审版师配置
export const config_delete_config_craftsman_ref_post_ = async function(params) {
  const {
    success,
    data,
    retInfo
  } = await config_delete_config_craftsman_ref_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 编辑工艺员审版师配置
export const config_edit_config_craftsman_ref_post_ = async function(params) {
  const {
    success,
    data,
    retInfo
  } = await config_edit_config_craftsman_ref_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 工艺员审版师配置
export const config_list_config_craftsman_ref_post_ = async function(params) {
  const {
    success,
    data,
    retInfo
  } = await config_list_config_craftsman_ref_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 功能性和特殊表才对应关系
export const config_list_config_function_special_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await config_list_config_function_special_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 新增 PO PO 通知配置
export const config_add_config_popo_notify_post_ = async function(params) {
  const { success, data, retInfo } = await config_add_config_popo_notify_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 删除 PO PO 通知配置
export const config_delete_config_popo_notify_post_ = async function(params) {
  const {
    success,
    data,
    retInfo
  } = await config_delete_config_popo_notify_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 编辑 PO PO 通知配置
export const config_edit_config_popo_notify_post_ = async function(params) {
  const { success, data, retInfo } = await config_edit_config_popo_notify_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 查询 PO PO 通知配置
export const config_list_config_popo_notify_post_ = async function(params) {
  const { success, data, retInfo } = await config_list_config_popo_notify_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 查询 PO PO 通知配置
export const config_all_config_popo_notify_post_ = async function(params) {
  const { success, data, retInfo } = await config_all_config_popo_notify_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 批量删除 PO PO 通知配置
export const config_batch_delete_config_popo_notify_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await config_batch_delete_config_popo_notify_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 批量启用/停用 PO PO 通知配置
export const config_batch_update_config_popo_notify_status_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await config_batch_update_config_popo_notify_status_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 删除 PO PO 通知配置-列内容
export const config_delete_config_popo_notify_content_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await config_delete_config_popo_notify_content_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 根据流程id计算timeline计划结束时间
export const config_timeline_getTimeLineEndTime_post_ = async function(params) {
  const {
    success,
    data,
    retInfo
  } = await config_timeline_getTimeLineEndTime_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}
